import { type EntityType, type SmartLinkResponse } from '@atlaskit/linking-types';

/*
 * ###########################################################################
 * Entity extraction
 * ###########################################################################
 *
 * Extractors for Smart Link entity data and entity-backed provider metadata.
 */
export const extractEntity = (response?: SmartLinkResponse): EntityType | undefined =>
	response?.entityData;
